import { useRef } from 'react';

const usePreviousValue = ({ value, onChangeRef, }) => {
    const valueRef = useRef({
        previous: value,
        present: value,
    });
    valueRef.current.present = value;
    if (value !== valueRef.current.previous) {
        valueRef.current.previous = value;
        onChangeRef.current?.(valueRef.current);
    }
};

export { usePreviousValue as u };
//# sourceMappingURL=hook-Asj8mXsM.js.map
